export const CONSENT_COOKIE_NAME = "sq_consent";
export const CONSENT_VERSION = 1;
export const CONSENT_COOKIE_MAX_AGE_DAYS = 365;
export const CONSENT_LOCALSTORAGE_KEY = "sq:consent:v1";

export const CONSENT_CATEGORIES = [
	"necessary",
	"preferences",
	"analytics",
	"marketing",
] as const;

export type ConsentCategory = (typeof CONSENT_CATEGORIES)[number];

export const DEFAULT_CONSENT_CATS: Record<ConsentCategory, boolean> = {
	necessary: true,
	preferences: false,
	analytics: false,
	marketing: false,
};

export interface ConsentRecord {
	v: number;
	ts: number;
	cats: Record<ConsentCategory, boolean>;
}

export type ConsentStatus = "unknown" | "decided";
